import { createPinia } from 'pinia';

// Import all store modules
import { useReportsStore } from './modules/reportsStore';
import { useGlossaryStore } from './modules/glossaryStore';
import { useCompareStore } from './modules/compareStore';
import { useAppStore } from './app';

// Re-export types
export type { Report } from './modules/reportsStore';

// Create and export Pinia instance
const pinia = createPinia();
export default pinia;

// Export store composables
export {
  useReportsStore,
  useGlossaryStore,
  useCompareStore,
  useAppStore
}; 